import i18next from 'src/i18n';
import queryString from 'query-string';

export const convertToolTip = (toolTips, returnString) => {
  if (Array.isArray(toolTips)) {
    const lng = i18next.language;
    const translatedArr = toolTips.map(msg => msg[lng]);
    if (returnString) {
      let str = '';
      toolTips.forEach(msg => (str += `<p>${msg[lng]}</p>`));
      return str;
    }
    return (
      <div>{translatedArr.map((text, i) => <p key={`${text.slice(10)}-${i}`}>{text}</p>)}</div>
    );
  }
  return null;
};

export const getParamsWithHash = () => {
  const queryObj = queryString.parse(window.location.search);
  const params = Object.assign({}, queryObj);
  // %2B -> %252B (it's "+" symbol)
  params.encodeHash = params.hash && encodeURIComponent(encodeURIComponent(params.hash));

  if (params.lang) {
    i18next.changeLanguage(params.lang);
  }
  return params;
};

export const openInWebView = window.location.hash === '#inWebView';
